<div *ngIf="isAdminObservable | async as isAdmin" class="card">
	<div class="card-body">
		<al-tabs [tabInfo]="tabInfo" [selectedTab$]="selectedTab$"></al-tabs>

		<div class="tabs-container">
			<ng-container [ngSwitch]="selectedTab$ | async">
				<ng-container *ngSwitchCase="1">
					<app-shell-admin-link-display></app-shell-admin-link-display>
				</ng-container>

				<ng-container *ngSwitchCase="2">
					<hr>
					<al-tabs [tabInfo]="tabInfoAuditLogs" [selectedTab$]="selectedAuditLogsTab$"></al-tabs>

					<ng-container [ngSwitch]="selectedAuditLogsTab$ | async">
						<ng-container *ngSwitchCase="1">
							<app-shell-admin-audit-logs-companies-users></app-shell-admin-audit-logs-companies-users>
						</ng-container>
						<ng-container *ngSwitchCase="2">
							<app-shell-admin-audit-user-management></app-shell-admin-audit-user-management>
						</ng-container>
						<ng-container *ngSwitchCase="3">
							<app-shell-admin-audit-logs-links></app-shell-admin-audit-logs-links>
						</ng-container>
						<ng-container *ngSwitchCase="4">
							<app-shell-admin-audit-logs-links-linksettings-updates></app-shell-admin-audit-logs-links-linksettings-updates>
						</ng-container>
						<ng-container *ngSwitchCase="5">
							<app-shell-admin-audit-logs-permissions></app-shell-admin-audit-logs-permissions>
						</ng-container>
						<ng-container *ngSwitchCase="6">
							<app-shell-admin-audit-logs-functionapp></app-shell-admin-audit-logs-functionapp>
						</ng-container>
					</ng-container>

				</ng-container>
				<ng-container *ngSwitchCase="3">
					<app-shell-admin-financial-issues-overview></app-shell-admin-financial-issues-overview>
				</ng-container>

				<ng-container *ngSwitchCase="4">
					<app-shell-admin-queue-link-overview></app-shell-admin-queue-link-overview>
				</ng-container>
				<ng-container *ngSwitchCase="5">
					<app-admin-link-maintenance></app-admin-link-maintenance>
				</ng-container>
			</ng-container>
		</div>
	</div>
</div>
